var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v(" "+_vm._s(_vm.title)+" ")]):(_vm.rowData)?_c('span',[_vm._v(" "+_vm._s(_vm.getDay(_vm.rowData.request))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }